// extracted by mini-css-extract-plugin
export var actions = "_uk-4";
export var item = "_uk-1";
export var price = "_uk-3";
export var quantity = "_uk-2";
export var table = "_uk-0";